import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Sidebar from './components/sidebar/sidebar.js';
import ChatSeaction from './components/chatseasction/chatseaction.js';
import Spereation from './components/seperation/Spereation.js';
import UserContext from './components/context/userContect.js';
import Aivoice from './aivoice/Ai_Voice_page/Aivoice.js';
import Sidebarai from './aivoice/sidebarai page/Sidebarai.js';
import { AuthProvider } from './context/AuthContext';
import Login from './components/auth/Login';
import SignUp from './components/auth/SignUp';
import ForgotPassword from './components/auth/ForgotPassword';
import PrivateRoute from './components/auth/PrivateRoute';
import Humanizetext from './humanizetext/Humanizetext.js';
import AiVideoGen from './AiVideoGen/AiVideoGen.js';
import Ainagev2 from './ai image create/Aimage.js';
// import GenerateImage from './ai image create/imagegenV2.js';
// import WebsiteDesigner from './websiteresourse/websiteDesigning.js';
// import websitedesinger from './websiteresourse/websiteDesigning.js';


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <UserContext>
                  <div style={{ display: 'flex', width: '100%' }}>
                    <Sidebar />
                    <Spereation />
                    <ChatSeaction />
                  </div>
                </UserContext>
              </PrivateRoute>
            }
          />
          <Route
            path="/Aivoice"
            element={
              <PrivateRoute>
                <UserContext>
                  <div style={{ display: 'flex', width: '100%' }}>
                    <Sidebarai />
                    <Spereation />
                    <Aivoice />
                  </div>
                </UserContext>
              </PrivateRoute>
            }
          />
          <Route
            path="/Humanizetext"
            element={
              <PrivateRoute>
                <UserContext>
                  <div style={{ display: 'flex', width: '100%' }}>
                    <Sidebarai />
                    <Spereation />
                    <Humanizetext />
                  </div>
                </UserContext>
              </PrivateRoute>
            }
          />
          <Route
            path="/AiVideoGen"
            element={
              <PrivateRoute>
                <UserContext>
                  <div style={{ display: 'flex', width: '100%' }}>
                    <Sidebarai />
                    <Spereation />
                    <AiVideoGen />
                  </div>
                </UserContext>
              </PrivateRoute>
            }
          />
          <Route
            path="/Aimagev2"
            element={
              <PrivateRoute>
                <UserContext>
                  <div style={{ display: 'flex', width: '100%' }}>
                    <Sidebarai />
                    <Spereation />
                    <Ainagev2 />
                  </div>
                </UserContext>
              </PrivateRoute>
            }
          />
          {/* <Route
            path="/websiteDesigning"
            element={
              <PrivateRoute>
                <UserContext>
                  <div style={{ display: 'flex', width: '100%' }}>
                    <Sidebarai />
                    <Spereation />
                    <WebsiteDesigner />
                  </div>
                </UserContext>
              </PrivateRoute>
            }
          /> */}
          {/* <Route
            path="/Aimage"
            element={
              <PrivateRoute>
                <UserContext>
                  <div style={{ display: 'flex', width: '100%' }}>
                    <Sidebarai />
                    <Spereation />
                    <Aimage />
                  </div>
                </UserContext>
              </PrivateRoute>
            }
          /> */}
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
